import { print } from 'graphql'
import { Cart } from 'shopify-types'

import { storefrontClient } from '..'
import { CreateCartDocument, type CreateCartMutation } from '../__generated/storefront'
import { GlobalRequestOptions } from '../types'
import { GQLBuyerIdentityInput, mapGQLCartToCart } from './graphql'

type CreateCartInput = Readonly<{
  buyerIdentity?: GQLBuyerIdentityInput
  lines?: Readonly<{ merchandiseId: string; quantity: number }>[]
}>

export const createCart =
  (options: GlobalRequestOptions) =>
  async (input?: CreateCartInput): Promise<Cart> => {
    const response = await storefrontClient.request<CreateCartMutation>(print(CreateCartDocument), {
      variables: {
        input: {
          ...input,
          buyerIdentity: {
            countryCode: options.country,
            ...input?.buyerIdentity,
          },
        },
        language: options.language,
        country: options.country,
      },
    })

    const payload = response.data?.cartCreate

    if (!payload?.cart) {
      throw new Error('Failed to create cart')
    }

    return mapGQLCartToCart(payload.cart)
  }
